import { createAppLayoutPartLoader } from "@amzn/awsui-app-layout-loader";
import {
  createWidgetizedAppLayoutDrawer,
  AppLayoutDrawerImplementation,
  createWidgetizedAppLayoutGlobalDrawers,
  AppLayoutGlobalDrawersImplementation,
} from "./drawer";
import { createWidgetizedAppLayoutNavigation, AppLayoutNavigationImplementation } from "./navigation";
import { createWidgetizedAppLayoutNotifications, AppLayoutNotificationsImplementation } from "./notifications";
import {
  createWidgetizedAppLayoutSplitPanelDrawerBottom,
  AppLayoutSplitPanelDrawerBottomImplementation,
  createWidgetizedAppLayoutSplitPanelDrawerSide,
  AppLayoutSplitPanelDrawerSideImplementation,
} from "./split-panel";
import { createWidgetizedAppLayoutToolbar, AppLayoutToolbarImplementation } from "./toolbar";

export const AppLayoutDrawer = createWidgetizedAppLayoutDrawer(
  createAppLayoutPartLoader({ partName: "AppLayoutDrawer", Fallback: AppLayoutDrawerImplementation }),
);
export const AppLayoutGlobalDrawers = createWidgetizedAppLayoutGlobalDrawers(
  createAppLayoutPartLoader({ partName: "AppLayoutGlobalDrawers", Fallback: AppLayoutGlobalDrawersImplementation }),
);
export const AppLayoutNavigation = createWidgetizedAppLayoutNavigation(
  createAppLayoutPartLoader({ partName: "AppLayoutNavigation", Fallback: AppLayoutNavigationImplementation }),
);
export const AppLayoutNotifications = createWidgetizedAppLayoutNotifications(
  createAppLayoutPartLoader({ partName: "AppLayoutNotifications", Fallback: AppLayoutNotificationsImplementation }),
);
export const AppLayoutSplitPanelBottom = createWidgetizedAppLayoutSplitPanelDrawerBottom(
  createAppLayoutPartLoader({
    partName: "AppLayoutSplitPanelBottom",
    Fallback: AppLayoutSplitPanelDrawerBottomImplementation,
  }),
);
export const AppLayoutSplitPanelSide = createWidgetizedAppLayoutSplitPanelDrawerSide(
  createAppLayoutPartLoader({
    partName: "AppLayoutSplitPanelSide",
    Fallback: AppLayoutSplitPanelDrawerSideImplementation,
  }),
);
export const AppLayoutToolbar = createWidgetizedAppLayoutToolbar(
  createAppLayoutPartLoader({ partName: "AppLayoutToolbar", Fallback: AppLayoutToolbarImplementation }),
);
